import { Grid, Heading } from '@raskrask-dk/rr-components'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBFSM } from '../../contexts/bfsmContext'
import { useAppSelector } from '../../redux/hooks'
import {
    getBookingId,
    getErrorCase,
    getIsMobile,
} from '../../redux/reducers/appSettings'
import { PageTemplate } from '../chemistry/skeleton'
import { StyledErrorPage } from './error.styles'
import { ErrorTemplate } from './error.template'
import { ErrorPageButtonTypes } from './error.props'
import { useDetermineErrorPageContent } from './error.hooks'
import { DetailsState } from '@raskrask-dk/bookingflow-state-machine'
/**
 *
 * @param
 * @returns the ErrorPage corresponding with the 'ErrorCase' set in Redux
 */
const ErrorPage = (): ReactElement => {
    const [BFSM] = useBFSM()
    const { t } = useTranslation()
    const errorCase = useAppSelector((state) => getErrorCase(state))
    const isMobile = useAppSelector((state) => getIsMobile(state))
    const bookingId = useAppSelector((state) => getBookingId(state))

    const [buttonType, setButtontype] =
        useState<ErrorPageButtonTypes>('NoButton')
    const [primaryTextBlock, setPrimaryTextBlock] = useState<string>('')
    useDetermineErrorPageContent(
        setButtontype,
        setPrimaryTextBlock,
        BFSM,
        errorCase
    )

    const onClickResetFlowButton = () => {
        window.location.assign('/')
    }

    const onClickRebookButton = () => {
        window.location.assign(`/rebook/${bookingId}`)
    }

    const onClickGoToCalendarButton = () => {
        const prevData = BFSM.getData<DetailsState>()
        BFSM.addSuggestions = {
            customerName: prevData.customerName,
            customerPhone: prevData.customerPhone,
            customerEmail: prevData.customerEmail,
            companyAdminName: prevData.companyAdminName,
            companyName: prevData.companyName,
            bookingReasons: prevData.bookingReasons,
            parkingText: prevData.parkingText,
            problemDescription: prevData.problemDescription,
        }
        BFSM.goBack() // errorstate -> checkoutstate
        BFSM.goBack() // checkoutstate -> detailsstate
        BFSM.goBack() // detailsstate -> calendarstate
    }

    const onClickHandler =
        buttonType === 'Rebook'
            ? onClickRebookButton
            : buttonType === 'RestartFlow'
            ? onClickResetFlowButton
            : buttonType === 'GoToCalendar'
            ? onClickGoToCalendarButton
            : () => {
                  console.log('No onClickHandler defined for this buttonType')
                  return
              }

    const top = (
        <Heading level={1} bold primary size={isMobile ? 3 : 1}>
            {t('errorpage.header.text')}
        </Heading>
    )

    const buttonText =
        buttonType === 'Rebook'
            ? t('errorpage.gotorebooking.button.text')
            : buttonType === 'RestartFlow'
            ? t('errorpage.startover.button.text')
            : buttonType === 'GoToCalendar'
            ? t('errorpage.gotocalendar.button.text')
            : ''

    const body = (
        <StyledErrorPage>
            <ErrorTemplate
                textHandler={[primaryTextBlock]}
                buttonHandler={[onClickHandler, buttonText, buttonType]}
            ></ErrorTemplate>
        </StyledErrorPage>
    )

    return (
        <PageTemplate
            Top={
                isMobile ? (
                    <Grid gap="16">
                        {top}
                        {body}
                    </Grid>
                ) : (
                    top
                )
            }
            Body={!isMobile && body}
            Modal={undefined}
            bodyOverlap={!isMobile}
            hideBackButton
        />
    )
}

export default ErrorPage
